// Inline SVGs (so they inherit currentColor)
const ICON_CLOSE = '<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" fill="currentColor"/></svg>'
const ICON_ARROW = '<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 448 512"><path fill="currentColor" d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg>'

const createSingletonLightbox = () => {
    if (window.__Lightbox) return window.__Lightbox

    const dlg = document.createElement('dialog')
    dlg.setAttribute('aria-modal', 'true')
    dlg.className = 'p-0 bg-transparent'

    dlg.innerHTML = `
      <div class="fixed inset-0 flex items-center justify-center bg-black/85 p-4">
        <div class="relative w-full h-full max-w-full max-h-full">
          <img class="w-full h-full object-contain" alt="" />
          <div class="absolute bottom-2 right-2 text-white/90 text-sm js-lightbox-counter"></div>
          <button class="cursor-pointer absolute top-2 right-2 p-2 text-white" aria-label="Close"></button>
          <button class="cursor-pointer absolute left-2 top-1/2 -translate-y-1/2 p-2 text-white" aria-label="Previous"></button>
          <button class="cursor-pointer absolute right-2 top-1/2 -translate-y-1/2 p-2 text-white" aria-label="Next"></button>
        </div>
      </div>
    `

    document.body.appendChild(dlg)

    const imgEl = dlg.querySelector('img')
    const counterEl = dlg.querySelector('.js-lightbox-counter')
    const btnClose = dlg.querySelector('[aria-label="Close"]')
    const btnPrev = dlg.querySelector('[aria-label="Previous"]')
    const btnNext = dlg.querySelector('[aria-label="Next"]')

    // Inject SVGs so they can inherit currentColor
    if (btnClose) btnClose.innerHTML = `<span class="inline-block w-6 h-6">${ICON_CLOSE}</span>`
    if (btnPrev) btnPrev.innerHTML = `<span class="inline-block w-6 h-6" style="transform: rotate(180deg)">${ICON_ARROW}</span>`
    if (btnNext) btnNext.innerHTML = `<span class="inline-block w-6 h-6">${ICON_ARROW}</span>`

    const state = { images: [], index: 0 }

    const render = () => {
        if (!state.images.length) return
        imgEl.src = state.images[state.index]
        if (counterEl) {
            counterEl.textContent = `${state.index + 1} / ${state.images.length}`
        }
    }

    const open = (images, index = 0) => {
        state.images = images || []
        state.index = Math.min(Math.max(0, index), Math.max(0, state.images.length - 1))
        render()
        if (typeof dlg.showModal === 'function') dlg.showModal()
        btnClose?.focus()
    }

    const close = () => dlg.close()
    const next = () => {
        if (!state.images.length) return
        state.index = (state.index + 1) % state.images.length
        render()
    }
    const prev = () => {
        if (!state.images.length) return
        state.index = (state.index - 1 + state.images.length) % state.images.length
        render()
    }

    btnClose.addEventListener('click', close)
    btnPrev.addEventListener('click', prev)
    btnNext.addEventListener('click', next)
    dlg.addEventListener('keydown', (e) => {
        e.stopPropagation()
        if (e.key === 'ArrowRight') { e.preventDefault(); next() }
        if (e.key === 'ArrowLeft') { e.preventDefault(); prev() }
        if (e.key === 'Escape') { e.preventDefault(); close() }
    })
    dlg.addEventListener('click', (e) => {
        e.stopPropagation()
        const rect = imgEl.getBoundingClientRect()
        if (e.target === dlg || (e.clientY < rect.top || e.clientY > rect.bottom || e.clientX < rect.left || e.clientX > rect.right)) {
            close()
        }
    })

    window.__Lightbox = { open, close, next, prev }
    return window.__Lightbox
}

const registerLightboxGallery = (Alpine) => {
    createSingletonLightbox()
    Alpine.data('lightboxGallery', (initial = {}) => ({
        images: initial.images || [],
        open(i = 0) {
            if (!this.images.length || !window.__Lightbox) return
            window.__Lightbox.open(this.images, i)
        }
    }))
}

export default {
    init(Alpine) {
        registerLightboxGallery(Alpine)
    }
}


